import { useState, useEffect } from "react";
import Modal from "./Modal";
import HTMLReactParser from "html-react-parser";
import Select from "react-select";

export default function ExtrasCard({
  cardContent,
  selected = false,
  onSelect,
  inputValue,
  channels = false,
}) {
  const [modal, setModal] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const url =
    process.env.NODE_ENV === "development"
      ? "./"
      : "/wp-content/reactpress/apps/sdh-booking-form/public/";

  useEffect(() => {
    setIsSelected(selected);
  }, [selected]);

  const handleSelectChange = (e, v) => {
    const info = { ...e, title: cardContent.title };
    setIsSelected(!isSelected);
    onSelect(v.name, info);
  };

  const handleButtonSelect = (e, v) => {
    const info = {
      label: e.target.getAttribute("data-label"),
      value: !isSelected ? parseInt(e.target.getAttribute("data-value")) : 0,
      title: cardContent.title,
    };
    setIsSelected(!isSelected);
    onSelect(e.target.id, info);
  };

  const handleNumberChange = (e, v) => {
    const price = e.target.getAttribute("data-price-per") * e.target.value;
    const info = {
      label: `£${price}`,
      value: parseInt(e.target.value),
      title: cardContent.title,
      price: price,
    };
    setIsSelected(price > 0 ? true : false);
    onSelect(e.target.id, info);
  };

  const options = cardContent.options;

  const musicOptions = ["music_device", "apple_adaptor", "google_adaptor"];
  if (musicOptions.includes(cardContent.id) === true) {
    options.forEach((option) => {
      if (option.maxChannels > 2 && channels <= 2) {
        option["disabled"] = true;
      } else {
        option["disabled"] = false;
      }
    });
  }

  return (
    <article
      className={`text-center border rounded-3xl p-4 bg-gradient-to-br from-light to-white shadow-lg ${
        isSelected ? "border-primary shadow-primary border-2" : "border-dark/50"
      }`}
    >
      <img
        src={url + cardContent?.image.url}
        alt={cardContent?.image.alt}
        className="mx-auto mb-4 max-h-52 rounded-2xl border border-primary"
      />
      <h4 className="md:h-16 font-sans">{cardContent?.title}</h4>

      {cardContent.optionsInput === "select" && (
        <Select
          name={cardContent.id}
          options={options}
          className={`react-select-container ${isSelected ? "selected" : ""}`}
          styles={{
            option: (baseStyles, state) => ({
              ...baseStyles,
              opacity: state.isDisabled ? "0.5" : "1",
            }),
          }}
          classNamePrefix="react-select"
          placeholder="Add"
          value={options.find((option) => option.value === inputValue)}
          onChange={handleSelectChange}
          isOptionDisabled={(option) => {
            return option.disabled;
          }}
        />
      )}

      {cardContent.optionsInput === "button" && (
        <p
          id={cardContent.id}
          className={`btn !font-sans !py-4 !mr-0 !text-xl !w-full ${
            isSelected ? "!bg-primary !text-light" : ""
          }`}
          onClick={handleButtonSelect}
          data-label={options[0].label}
          data-value={options[0].value}
        >
          {options[0].label}
        </p>
      )}

      {cardContent.optionsInput === "number" && (
        <input
          id={cardContent.id}
          name={cardContent.id}
          type="number"
          min={0}
          defaultValue={inputValue}
          placeholder={0}
          onBlur={handleNumberChange}
          data-price-per={options[0]?.value}
          className="btn !py-4 !mr-0 !text-xl !w-full text-center !font-sans"
        />
      )}
      <p
        className="btn btn-primary !font-sans !mb-0 !mr-0 !text-lg !w-full"
        onClick={() => setModal(!modal)}
      >
        View details
      </p>

      <Modal show={modal} closeModal={() => setModal(!modal)}>
        <div className="flex flex-wrap items-center justify-between">
          <div
            className={`${
              cardContent?.video ? "md:w-1/3" : "md:w-1/2"
            } text-left`}
          >
            <h4>{cardContent?.title}</h4>
            {cardContent?.details && HTMLReactParser(cardContent?.details)}
          </div>
          <div
            className={`${
              cardContent?.video ? "w-full md:w-2/3" : "w-full md:w-1/2"
            } md:pl-4`}
          >
            {cardContent?.video ? (
              <iframe
                class="w-full aspect-video rounded-3xl"
                src={`${url + cardContent.videoThumbnail.url}&autoplay=1`}
                srcdoc={`<style>img,span{margin:auto}.overlay,img,span{position:absolute;width:100%}.overlay,body,html,span{height:100%}*{padding:0;margin:0;overflow:hidden}img{top:0;bottom:0}span{top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;z-index:10;display:flex;align-items:center;justify-content:center}.overlay{background:rgba(26,26,26,.5)}svg{width:25%;transform:scale(1);transition:.3s}a:hover svg{transition:.3s;transform:scale(1.1)}</style><a href="${
                  cardContent?.videoUrl
                }?autoplay=1" class="group"><img src="${
                  url + cardContent.videoThumbnail.url
                }" alt="Extras to hire from The Silent Disco Company"><span><svg data-name="Play button"id=Play_button viewBox="0 0 329.872 293.568"><defs><filter filterUnits=userSpaceOnUse height=293.568 id=What-is-Silent-Disco width=329.872 x=0 y=0><feOffset input=SourceAlpha /><feGaussianBlur result=blur stdDeviation=7.5 /><feFlood flood-color=#4acbbb /><feComposite in2=blur operator=in /><feComposite in=SourceGraphic /></filter></defs><g transform="translate(-1241.148 -8064.251)"data-name="Group 1168"id=Group_1168><g transform="matrix(1, 0, 0, 1, 1241.15, 8064.25)"filter=url(#What-is-Silent-Disco)><path d=M3.6,0,0,221l261-3.024L251.1,19.536Z data-name=What-is-Silent-Disco fill=#4acbbb id=What-is-Silent-Disco-2 transform="matrix(-1, -0.09, 0.09, -1, 285.36, 268.16)"stroke=#4acbbb stroke-width=5 /></g><path d=M62.787,31.761,10.711.974C6.48-1.526,0,.9,0,7.084V68.643a7.1,7.1,0,0,0,10.711,6.11L62.787,43.981A7.094,7.094,0,0,0,62.787,31.761Z data-name="Icon awesome-play"fill=#fff id=Icon_awesome-play transform="translate(1373.499 8172.498)"/></g></svg></span><div class="overlay"></div></a>`}
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                title="The Silent Disco Company YouTube Video"
              ></iframe>
            ) : (
              <img
                src={url + cardContent.image.url}
                alt={cardContent.image.alt}
                className="mx-auto"
              />
            )}
          </div>
        </div>
      </Modal>
    </article>
  );
}
